export default __webpack_public_path__ + "static/media/flag.d2b6897a.svg";